import { observer } from 'mobx-react-lite'
import DynamicTableComponent from '../DynamicTable/DynamicTableComponent'
import { useEffect, useState } from 'react'
import { useStore } from '../../app/stores/store'
import { initialPostFilteredItemDetails, PostFilteredItemDetailsTypes } from '../../app/models/metaDataConfig'

const NFAIRestorationDashboard = () => {
  const { metaDataStore, dashboardStore } = useStore();
  const [pageNo, setPageNo] = useState(1)
  useEffect(()=>{
    metaDataStore.PostFilteredItemDetailsHandler(initialPostFilteredItemDetails)
    //eslint-disable-next-line
  },[])

  useEffect(() => {
    if (dashboardStore.dashboard.setTagTablePageNumber === 1) {
      setPageNo(dashboardStore.dashboard.setTagTablePageNumber);
    }
  }, [dashboardStore.dashboard.setTagTablePageNumber]);
  
    const paginateFunction = (e: number) => {
      const newObj = dashboardStore.dashboard.searchfilterparams;
      const payload:PostFilteredItemDetailsTypes = {
        ...initialPostFilteredItemDetails,
        PageNumber: e,
        title: newObj?.title || '',
        currentTask: newObj?.current_task || dashboardStore.dashboard.setProductionType || '',
        currentSubtask: newObj?.current_subtask || dashboardStore.dashboard.setProductionTask || '',
        status: newObj?.status || '',
        Previoustask: newObj?.previoustask || newObj?.previousTask || '',
        PreviousSubtask: newObj?.previoussubtask || newObj?.previousSubtask || '',
      }
    metaDataStore.PostFilteredItemDetailsHandler(payload)
    dashboardStore.setTagPageNumFunc(e);
    setPageNo(e);
  };

    const searchFunction = (column: any, order: any) => {
    console.log(order, column);
  };

  return (
    <div>
      <DynamicTableComponent
        data={metaDataStore.NfaiRestorationDashboardInfo.data}
        name={'NFAIRestorationDashboard'} 
        actiontype={''} 
        pageFunc={paginateFunction} 
        pageNumData={pageNo} 
        searchFuncData={searchFunction}
        loading={metaDataStore.NfaiRestorationDashboardInfo.loading}
        />
    </div>
  )
}

export default observer(NFAIRestorationDashboard)